import React from 'react';

const SkeletonPromoBanners = () => {
    return (
        <div className="skeleton-promo-banners-wrapper xmt-8">
            <div className="container">
                <div className="banners-wrapper d-flex align-items-center">
                    <div className="banner-sk xpx-6 banner--green skeleton-loading">
                        <div className="price-box skeleton-loading position-absolute"></div>
                        <div className="text-box">
                            <div className="text-sk skeleton-loading text--1"></div>
                            <div className="text-sk skeleton-loading text--2 xmt-2"></div>
                        </div>
                        <div className="button-sk skeleton-loading xmt-8"></div>
                    </div>
                    <div className="banner-sk xpx-6 xmr-6 banner--yellow skeleton-loading">
                        <div className="price-box skeleton-loading position-absolute"></div>
                        <div className="text-box">
                            <div className="text-sk skeleton-loading text--1"></div>
                            <div className="text-sk skeleton-loading text--2 xmt-2"></div>
                        </div>
                        <div className="button-sk skeleton-loading xmt-8"></div>
                    </div>
                    <div className="banner-sk xpx-6 xmr-6 banner--orange skeleton-loading">
                        <div className="price-box skeleton-loading position-absolute"></div>
                        <div className="text-box">
                            <div className="text-sk skeleton-loading text--1"></div>
                            <div className="text-sk skeleton-loading text--2 xmt-2"></div>
                        </div>
                        <div className="button-sk skeleton-loading xmt-8"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonPromoBanners;
